/**
 * 2026-11-04 (errors-fixes · C) — Stripe's own limit on a coupon's name, for
 * every surface that composes or checks one.
 *
 * A STANDALONE, dependency-free module (like `connectors.ts`): the dashboard
 * SPA's coupon form reads it, as do `create_stripe_coupon`'s input schema and
 * the speed-to-lead welcome saga, which composes its coupon's name.
 */

/**
 * The longest `name` Stripe accepts on a coupon, in characters ("…" and "—"
 * count one each; checked against Stripe's test mode on 4 Nov 2026). The
 * schema allowed 200, so a longer name passed the chokepoint and failed at
 * Stripe as `stripe_invalid_request` (/errors 01a17d9b, 27 Oct).
 */
export const STRIPE_COUPON_NAME_MAX_LENGTH = 40;
